class DesignerTextMenu {

  constructor(config) {
    this.app = config.app;


    safeAddListener("add_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createTextNode({});
    });

    safeAddListener("add_curved_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createTextPathNode({});
    });

    safeAddListener("add_quadratic_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createQuadraticTextPathGroupNode();
    });

    safeAddListener("add_bezier_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createBezierTextPathGroupNode();
    });

    safeAddListener("add_sinewave_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createSinewaveTextPathNode();
    });

    safeAddListener("add_circle_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createCircleTextPathNode();
    });

    safeAddListener("add_ellipse_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createEllipseTextPathNode();
    });

    safeAddListener("add_rectangle_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createRectangleTextPathNode();
    });

    safeAddListener("add_sided_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createSidedTextPathNode();
    });

    safeAddListener("add_heart_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createHeartTextPathNode();
    });

    safeAddListener("add_star_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createStarTextPathNode();
    });

    safeAddListener("add_teardrop_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createTeardropTextPathNode();
    });

    safeAddListener("add_spiral_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createSpiralTextPathNode();
    });

    safeAddListener("add_square_spiral_text", "click", () => {
      if (!this.app.getBaseLayer()) { showMessage("Notice", "You must select a Cribbage board first"); return; }
      this.createSquareSpiralTextPathNode();
    });


    document.getElementById("textDirection").addEventListener("change", function () {
      let obj = this.app.getSelectedNode();
      let newDir = document.getElementById("textDirection").value;
      //console.log("text Direction", obj, newDir, obj.getText());

      if (obj && obj.attrs.type == "text") {
        obj.attrs.direction = newDir;

        if (obj.attrs.direction == "Horizontal") {
          obj.setText(makeStringHorizontal(obj.getText()));
        } else if (obj.attrs.direction == "Vertical") {
          obj.setText(makeStringVertical(obj.getText()));
        }

        //console.log("text set", obj.getText());
      }
    }.bind(this));
  }






  createTextNode(attrs) {
    //console.log("createTextNode", attrs);
    //console.log("getBaseLayer", getBaseLayer());

    /*
    let basePos = {
      x: getBaseLayer().getX(), 
      y: getBaseLayer().getY()
    };
    if (attrs && attrs.x) {
      basePos.x = attrs.x;
      basePos.y = attrs.y;
    }
    //console.log("createTextNode", basePos);
    */

    let basePos = {
      x: 100,
      y: 100
    };

    const newText = new Konva.Text({
      offsetX: 0,
      offsetY: 0,
      x: attrs.x ?? basePos.x,
      y: attrs.y ?? basePos.y,
      text: attrs.text ?? "Custom Text",
      fontSize: attrs.fontSize ?? 40,
      fontFamily: attrs.fontFamily ?? lastFont,
      fontStyle: attrs.fontStyle ?? "normal",

      fill: "#1d0200",
      draggable: false,
      align: "center",
      type: "text",
      direction: attrs.direction ?? "Horizontal",
      sortable: true,
    });


    /*
    newText.shadowColor("rgba(255, 255, 255, 0.2)");
    newText.shadowOffset({ x: 0, y: 2 });
    newText.shadowBlur(2);

    newText.shadowColor("rgba(0, 0, 0, 0.7)");
    newText.shadowOffset({ x: 0, y: -2 });
    newText.shadowBlur(2);
    */

    this.app.getLayer().add(newText);
    newText.zIndex(this.app.getNextNodePos());

    if (attrs.rotation) {
      newText.setRotation(attrs.rotation);
    }

    this.app.selectNode(newText);
  }


  createTextPathNode(attrs = {}) {
    //console.log("baseLayer", getBaseLayer());
    let baseCR = getBaseLayer().getClientRect();

    const newText = new Konva.TextPath({
      x: attrs.x ?? -((baseCR.width / 2) - (baseCR.x * 2)),
      y: attrs.y ?? -((baseCR.height / 2) - (baseCR.y * 2)),
      text: attrs.text ?? "CUSTOM TEXT",
      fontSize: attrs.fontSize ?? 20,
      fontFamily: attrs.fontFamily ?? lastFont,
      fontStyle: attrs.fontStyle ?? "normal",
      data: attrs.data ?? describeArc(400, 400, (attrs.fontSize ?? 20) * 6, 90, 0),
      angle: attrs.angle ?? 90,
      letterSpacing: attrs.letterSpacing ?? 1,
      draggable: false,
      fill: "#1d0200",
      align: "center",
      type: "textpath",
    });

    newText.shadowColor("rgba(255, 255, 255, 0.2)");
    newText.shadowOffset({ x: 0, y: 2 });
    newText.shadowBlur(2);

    newText.shadowColor("rgba(0, 0, 0, 0.7)");
    newText.shadowOffset({ x: 0, y: -2 });
    newText.shadowBlur(2);

    if (attrs.rotation) {
      newText.setRotation(attrs.rotation);
    }

    newText.on("dblclick dbltap", (evt) => {
      let id = evt.target.attrs.id;
      let sel = getSelectedNode();

      let newText = prompt("New Text", sel.text());
      if (newText) {
        sel.text(newText);
      }
    });

    this.app.getLayer().add(newText);
    this.app.selectNode(newText);
  }


  createQuadraticTextPathGroupNode(attrs = {}) {
    let quad = new QuadraticTextPathGroup({
      x: 200,
      y: 200,
      sortable: true,
      selectable: true,
    });
    this.app.getLayer().add(quad);
    quad.zIndex(this.app.getNextNodePos());
    quad.moveToTop();
    this.app.selectNode(quad);
    //console.log(quad1);
  }


  createBezierTextPathGroupNode(attrs = {}) {
    let bez = new BezierTextPathGroup({
      textPath: {
        text: "CUSTOM TEXT CUSTOM TEXT",
      },
      sortable: true,
      selectable: true,
    });
    this.app.getLayer().add(bez);
    bez.zIndex(this.app.getNextNodePos());
    bez.moveToTop();
    this.app.selectNode(bez);
    //console.log("bezier", bez1);
  }


  createSinewaveTextPathNode(attrs = {}) {
    const myNode = new SinewaveTextPath({
      x: attrs.x ?? 50,
      y: attrs.y ?? 50,
      fill: engraveColor,
      fontSize: attrs.fontSize ?? 24,
      fontFamily: attrs.fontFamily ?? lastFont,
      text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
      amplitude: attrs.amplitude ?? 80,
      frequency: attrs.frequency ?? 120,
      waves: attrs.waves ?? 3,
      rotation: attrs.rotation ?? 0,
      sortable: true,
      app: this.app
    });
    //console.log("myNode", myNode);
    this.app.getLayer().add(myNode);
    myNode.zIndex(this.app.getNextNodePos());
    this.app.selectNode(myNode);
  }


  createCircleTextPathNode(attrs = {}) {
    const myNode = new CircleTextPath({
      x: attrs.x ?? 50,
      y: attrs.y ?? 50,
      fill: engraveColor,
      fontSize: attrs.fontSize ?? 24,
      fontFamily: attrs.fontFamily ?? lastFont,
      text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
      radius: attrs.radius ?? 150,
      rotation: attrs.rotation ?? 0,
      canResize: true,
      sortable: true,
    });
    //console.log("myNode", myNode);
    this.app.getLayer().add(myNode);
    myNode.zIndex(this.app.getNextNodePos());
    this.app.selectNode(myNode);
  }


  createEllipseTextPathNode(attrs = {}) {
    const myNode = new EllipseTextPath({
      x: attrs.x ?? 50,
      y: attrs.y ?? 50,
      fill: engraveColor,
      fontSize: attrs.fontSize ?? 24,
      fontFamily: attrs.fontFamily ?? lastFont,
      text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
      radiusX: attrs.radiusX ?? 200,
      radiusY: attrs.radiusY ?? 100,
      rotation: attrs.rotation ?? 0,
      sortable: true,
    });
    //console.log("myNode", myNode);
    this.app.getLayer().add(myNode);
    myNode.zIndex(this.app.getNextNodePos());
    this.app.selectNode(myNode);
  }


  createRectangleTextPathNode(attrs = {}) {
    const myNode = new RectangleTextPath({
      x: attrs.x ?? 50,
      y: attrs.y ?? 50,
      fill: engraveColor,
      fontSize: attrs.fontSize ?? 24,
      fontFamily: attrs.fontFamily ?? lastFont,
      text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text 123',
      rectangleWidth: attrs.rectangleWidth ?? 400,
      rectangleHeight: attrs.rectangleHeight ?? 200,
      rectangleRadius: attrs.rectangleRadius ?? 20,
      rotation: attrs.rotation ?? 0,
      sortable: true,
    });
    //console.log("myNode", myNode);
    this.app.getLayer().add(myNode);
    myNode.zIndex(this.app.getNextNodePos());
    this.app.selectNode(myNode);
  }


  createSidedTextPathNode(attrs = {}) {
    const myNode = new SidedTextPath({
      x: attrs.x ?? 50,
      y: attrs.y ?? 50,
      fill: engraveColor,
      fontSize: attrs.fontSize ?? 24,
      fontFamily: attrs.fontFamily ?? lastFont,
      text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
      radius: attrs.radius ?? 200,
      sides: attrs.sides ?? 6,
      rotation: attrs.rotation ?? 0,
      sortable: true,
    });
    //console.log("myNode", myNode);
    this.app.getLayer().add(myNode);
    myNode.zIndex(this.app.getNextNodePos());
    this.app.selectNode(myNode);
  }


  createHeartTextPathNode(attrs = {}) {
    const myNode = new HeartTextPath({
      x: attrs.x ?? 50,
      y: attrs.y ?? 50,
      fill: engraveColor,
      fontSize: attrs.fontSize ?? 24,
      fontFamily: attrs.fontFamily ?? lastFont,
      text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
      width: attrs.width ?? 300,
      height: attrs.height ?? 300,
      rotation: attrs.rotation ?? 0,
      sortable: true,
    });
    //console.log("myNode", myNode);
    this.app.getLayer().add(myNode);
    myNode.zIndex(this.app.getNextNodePos());
    this.app.selectNode(myNode);
  }


  createStarTextPathNode(attrs = {}) {
    const myNode = new StarTextPath({
      x: attrs.x ?? 50,
      y: attrs.y ?? 50,
      fill: engraveColor,
      fontSize: attrs.fontSize ?? 24,
      fontFamily: attrs.fontFamily ?? lastFont,
      text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
      width: attrs.width ?? 300,
      height: attrs.height ?? 300,
      points: attrs.points ?? 5,
      radius: attrs.radius ?? 0.5,
      rotation: attrs.rotation ?? 0,
      sortable: true,
    });
    //console.log("myNode", myNode);
    this.app.getLayer().add(myNode);
    myNode.zIndex(this.app.getNextNodePos());
    this.app.selectNode(myNode);
  }


  createTeardropTextPathNode(attrs = {}) {
    const myNode = new TeardropTextPath({
      x: attrs.x ?? 50,
      y: attrs.y ?? 50,
      fill: engraveColor,
      fontSize: attrs.fontSize ?? 24,
      fontFamily: attrs.fontFamily ?? lastFont,
      text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
      width: attrs.width ?? 250,
      height: attrs.height ?? 400,
      rotation: attrs.rotation ?? 0,
      sortable: true,
    });
    //console.log("myNode", myNode);
    this.app.getLayer().add(myNode);
    myNode.zIndex(this.app.getNextNodePos());
    this.app.selectNode(myNode);
  }


  createSpiralTextPathNode(attrs = {}) {
    const myNode = new SpiralTextPath({
      x: attrs.x ?? 50,
      y: attrs.y ?? 50,
      fill: engraveColor,
      fontSize: attrs.fontSize ?? 24,
      fontFamily: attrs.fontFamily ?? lastFont,
      text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
      startRadius: attrs.startRadius ?? 10,
      endRadius: attrs.endRadius ?? 250,
      revolutions: attrs.revolutions ?? 4,
      sortable: true,
    });
    //console.log("myNode", myNode);
    this.app.getLayer().add(myNode);
    myNode.zIndex(this.app.getNextNodePos());
    this.app.selectNode(myNode);
  }


  createSquareSpiralTextPathNode(attrs = {}) {
    const myNode = new SquareSpiralTextPath({
      x: attrs.x ?? 50,
      y: attrs.y ?? 50,
      fill: engraveColor,
      fontSize: attrs.fontSize ?? 24,
      fontFamily: attrs.fontFamily ?? lastFont,
      text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
      size: attrs.size ?? 600,
      turns: attrs.turns ?? 12,
      spacing: attrs.spacing ?? 36,
      thickness: attrs.thickness ?? 3,
      sortable: true,
    });
    //console.log("myNode", myNode);
    this.app.getLayer().add(myNode);
    myNode.zIndex(this.app.getNextNodePos());
    this.app.selectNode(myNode);
  }


}






  